import { createContext } from 'react';
// @ts-ignore
export default /*#__PURE__*/createContext(null);